/**
 * @module common/errors/invalid-email
 */

/**
 * @extends Error
 * @classdesc Ошибка в введённом Email
 */
class InvalidEmailError extends Error {
  constructor(
    message = 'Некорректно указан Email',
    filename,
    lineNumber,
  ) {
    super(message, filename, lineNumber);
  }
}

export default InvalidEmailError;
